export const locales = {
    'en-us': {
        sharebutton_aria: 'Share',
    },
    'es-us': {
        sharebutton_aria: 'Cuota',
    },
};
//# sourceMappingURL=locales.js.map